import React, { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import './Registration.scss';
import { RegistrationUserData } from '../../components/forms/registration/RegistrationUserData';
import { GlobalRouteNames } from '../../models/Common';
import { Page404 } from '../404';

export const Registration: FC = () => {
  return (
    <Switch>
      <Route path={GlobalRouteNames.RegistrationPage} exact>
        <div className="registration-page page">
          <div className="registration-page__container container">
            <RegistrationUserData />
          </div>
        </div>
      </Route>
      <Route component={Page404} path={GlobalRouteNames.Page404} />
    </Switch>
  );
};
